(function () {
    'use strict';

    angular.module('plagiat2017App').controller('PaymentsInvoicesController',
        PaymentsInvoicesController);

    PaymentsInvoicesController.$inject = ['$localStorage', 'InvoicesQueryRequest', 'tableSettingsRequest',
        'SearchRequest', 'SearchService', 'InvoicesService', 'ModalService', 'PaymentsService', 'DetectInstanceService',
        'PlagiatValidationService', 'INVOICE_STATUS_CONSTANT', '$translate', '$mdDialog', 'CountryModel', 'PAYMENT_TYPE_CONSTANT',
        'COUNTRYCODECONSTANT', 'DateService'];

    function PaymentsInvoicesController($localStorage, InvoicesQueryRequest, tableSettingsRequest,
                                        SearchRequest, SearchService, InvoicesService, ModalService, PaymentsService, DetectInstanceService,
                                        PlagiatValidationService, INVOICE_STATUS_CONSTANT, $translate, $mdDialog, CountryModel,
                                        PAYMENT_TYPE_CONSTANT, COUNTRYCODECONSTANT, DateService) {
        var vm = this;
        vm.activeTab = 'paymentsInvoices';

        vm.queryRequest = new InvoicesQueryRequest();
        vm.queryRequest.limit = $localStorage.invoicesListlimit ? $localStorage.invoicesListlimit : vm.queryRequest.limit;
        vm.searchRequest = new SearchRequest();
        vm.searchRequest.search.status = 1;
        vm.searchRequest.search.romanian = DetectInstanceService.instance() === 'ro';
        vm.options = new tableSettingsRequest();
        vm.selected = [];
        vm.pickedIds = [];
        vm.selectedIdsContainAnInvalidEmail = false;
        vm.pickedInvoice = false;
        vm.showDetailsBlock = false;
        vm.details = {};
        vm.invoiceDetailsObj = {};
        vm.simpleSearch = true;
        vm.invoiceStatuses = INVOICE_STATUS_CONSTANT;
        vm.paymentTypes = PAYMENT_TYPE_CONSTANT;
        vm.fixDate = DateService.fixDate;

        vm.getInvoices = getInvoices;
        vm.processIssueInvoice = processIssueInvoice;
        vm.downloadInvoice = downloadInvoice;
        vm.markInvoiceAsIssued = markInvoiceAsIssued;
        vm.markInvoiceAsWaiting = markInvoiceAsWaiting;
        vm.markInvoiceAsIncorrect = markInvoiceAsIncorrect;
        vm.processGenerateBulkInvoice = processGenerateBulkInvoice;
        vm.selectInvoice = selectInvoice;
        vm.pagingAction = pagingAction;
        vm.clear = clear;
        vm.getInvoiceDetails = getInvoiceDetails;
        vm.editCompletedInvoice = editCompletedInvoice;
        vm.updateIssue = updateIssue;

        function getInvoices() {
            clearSelection();
            vm.showDetailsBlock = false;
            vm.searchRequest.pageNumber = vm.queryRequest.page - 1;
            vm.searchRequest.pageSize = vm.queryRequest.limit;
            vm.searchRequest.sortTab = SearchService.sort(vm.queryRequest);
            vm.isLoaderActive = true;
            InvoicesService.getInvoicesForSuperadmin(vm.searchRequest).then(function (responseData) {
                vm.responseObj = responseData.content;
                vm.invoices = vm.responseObj;
                vm.totalInvoices = responseData.totalElements;
                vm.isLoaderActive = false;
            });
        }

        function getInvoiceDetails(row) {
            vm.showDetailsBlock = false;

            if (row.id !== vm.invoiceDetailsObj.id) {
                vm.pickedInvoice = row.id;
                vm.invoiceDetailsObj = row;
                InvoicesService.getInvoiceDetails(row.id).then(function (result) {
                    vm.showDetailsBlock = true;
                    vm.details = result.data;
                });
            } else {
                vm.invoiceDetailsObj = {};
            }
        }

        function pagingAction(page) {
            vm.isLoaderActive = true;
            vm.queryRequest.page = page;
            vm.getInvoices();
        }

        function clear() {
            vm.searchRequest = new SearchRequest();
            vm.getInvoices();
        }

        function markInvoiceAsIssued(invoice) {
            ModalService.showConfirmModal().then(function () {
                vm.isLoaderActive = true;
                InvoicesService.markInvoiceAsIssued(invoice.id).then(
                    function () {
                        vm.getInvoices();
                        ModalService.showSuccessModal();
                    },
                    function (response) {
                        PlagiatValidationService.getModalError(response.data);
                        vm.isLoaderActive = false;
                    });
            });
        }
    
        function markInvoiceAsWaiting(invoice) {
            ModalService.showConfirmModal().then(function () {
                vm.isLoaderActive = true;
                InvoicesService.markInvoiceAsWaiting(invoice.id).then(
                    function () {
                        vm.getInvoices();
                        ModalService.showSuccessModal();
                    },
                    function (response) {
                        PlagiatValidationService.getModalError(response.data);
                        vm.isLoaderActive = false;
                    });
            });
        }

        function markInvoiceAsIncorrect(invoice) {
            ModalService.showConfirmModal().then(function () {
                vm.isLoaderActive = true;
                InvoicesService.markInvoiceAsIncorrect(invoice.id).then(
                    function () {
                        vm.getInvoices();
                        ModalService.showSuccessModal();
                    },
                    function (response) {
                        PlagiatValidationService.getModalError(response.data);
                        vm.isLoaderActive = false;
                    });
            });
        }

        function processGenerateBulkInvoice() {
            transformSelectedObj();
            generateBulkInvoice();
        }
    
        function generateBulkInvoice() {
            ModalService.showConfirmModal(null,
                vm.selectedIdsContainAnInvalidEmail ? {customWarning: $translate.instant("payments.invoice.warning.user.deleted")} : null)
                .then(function() {
                vm.isLoaderActive = true;
                InvoicesService.generateBulkInvoice(vm.pickedIds).then(
                    function () {
                        clearSelection();
                        vm.getInvoices();
                        ModalService.showSuccessModal();
                    },
                    function (response) {
                        PlagiatValidationService.getModalError(response.data);
                        vm.isLoaderActive = false;
                    });
            });
        }

        function processIssueInvoice(invoice) {
            InvoicesService.getInvoiceDetails(invoice.id).then(function (invoiceData) {
                issueInvoice(invoice, getCustomWarning(invoice, invoiceData));
            })
        }
    
        function issueInvoice(invoice, warnings) {
            ModalService.showConfirmModal(null, {customWarning: warnings})
                .then(function () {
                vm.isLoaderActive = true;
                InvoicesService.issueInvoice(invoice.id).then(
                    function () {
                        vm.getInvoices();
                        ModalService.showSuccessModal();
                    },
                    function (response) {
                        PlagiatValidationService.getModalError(response.data);
                        vm.isLoaderActive = false;
                    });
            });
        }

        function updateIssue(invoice) {
            ModalService.showConfirmModal().then(function () {
                    vm.isLoaderActive = true;
                    InvoicesService.updateIssue(invoice).then(
                        function () {
                            vm.getInvoices();
                            ModalService.showSuccessModal();
                        },
                        function (response) {
                            PlagiatValidationService.getModalError(response.data);
                            vm.isLoaderActive = false;
                        });
                });
        }
    
        function downloadInvoice(invoiceNumber) {
            PaymentsService.downloadInvoice(invoiceNumber).then(
                function () {},
                function (response) {
                    PlagiatValidationService.getModalError(response.data);
                });
        }
    
        function transformSelectedObj() {
            vm.pickedIds.length = 0;
            vm.selectedIdsContainAnInvalidEmail = false;
            angular.forEach(vm.selected, function (value) {
                if(!value.email.includes("@")){
                    vm.selectedIdsContainAnInvalidEmail = true;
                }
                vm.pickedIds.push(value.id);
            });
        }
    
        function selectInvoice(invoice) {
            if (invoice.status !== vm.invoiceStatuses.INVOICE_STATUS_WAITING.id
            && invoice.status !== vm.invoiceStatuses.INVOICE_STATUS_PAID.id) { // pozwalamy na zaznaczanie tylko ze statusem 3 oraz 0
                vm.selected = vm.selected.filter(function(el) {
                    return el.id !== invoice.id;
                });
            }
        }

        function editCompletedInvoice(invoice) {
            InvoicesService.getInvoiceDetails(invoice.id).then(function (result) {
                vm.invoice = result.data;
                $mdDialog.show({
                    templateUrl: 'app/account/payments/payments-invoices/payments-invoice.template.html',
                    clickOutsideToClose: true,
                    escapeToClose: true,
                    controllerAs: 'vm',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('payments');
                            $translatePartialLoader.addPart('country');
                            return $translate.refresh();
                        }]
                    },
                    locals: {
                        data: result.data
                    },
                    controller: function ($mdDialog, data) {
                        this.invoice = data;
                        this.isCompany = !!data.nip;
                        this.invoice.company = data.purchaser;
                        this.isRomania = vm.instanceLang === 'ro';
                        this.isPoland = vm.instanceLang === 'pl';
                        this.countries = new CountryModel();
                        if(this.isRomania){
                            this.invoice.country = COUNTRYCODECONSTANT.ROMANIA.code;
                        }
                        this.saveInvoice = function () {
                            if (!this.isCompany) {
                                this.invoice.nip = null;
                            }
                            vm.updateIssue(this.invoice)
                        }
                        this.closeDialog = function () {
                            $mdDialog.hide();
                        }
                    }
                })
            });
        }

        function getCustomWarning(invoice, invoiceData) {
            var warnings = '';

            if (!invoice.email.includes("@")) {
                warnings += $translate.instant("payments.invoice.warning.user.deleted");
            }

            if (!invoiceData.data.purchaser.length > 1) {
                if (warnings !== '') {
                    warnings += '. ';
                }
                warnings += $translate.instant("payments.payme.error.wrong-amount") + ': ' + $translate.instant("payments.table.invoice.purchaser");
            }
            if (!invoiceData.data.street) {
                if (warnings !== '') {
                    warnings += '. ';
                }
                warnings += $translate.instant("global.validation.required") + ': ' + $translate.instant("payments.metric.address.street");
            }
            if (!invoiceData.data.country && !invoiceData.data.county) {
                if (warnings !== '') {
                    warnings += '. ';
                }
                warnings += $translate.instant("global.validation.required") + ': ' + $translate.instant("payments.metric.address.invoice-country");
            }
            if (!invoiceData.data.city) {
                if (warnings !== '') {
                    warnings += '. ';
                }
                warnings += $translate.instant("global.validation.required") + ': ' + $translate.instant("payments.metric.address.city");
            }
            return warnings;
        }

        function clearSelection() {
            vm.selected = [];
            vm.pickedIds = [];
            vm.selectedIdsContainAnInvalidEmail = false;
        }

        vm.getInvoices();

    }
})();
